import React from 'react';

const ExecBioBody = ({ exec }) => (
  <div className="background-color-dark-slate padding-top-40 padding-horizontal-40 text-color-white height-100-p">
    <div className="text-size-18 text-weight-bold margin-bottom-10">
      { exec.get('name') }
    </div>
    <div className="text-size-18 font-family-georgia margin-bottom-20">
      { exec.get('title') }
    </div>
    <div className="text-size-16 text-weight-book">
      { exec.get('bio') }
    </div>
  </div>
);

export default ExecBioBody;

